/** Canonical URLs on alearninglab.com (global site). */
export const MAIN_SITE = {
  about: "https://alearninglab.com/about-us/",
  terms: "https://alearninglab.com/terms-and-conditions/",
};

/** In-app routes on the India site (router basename /in). */
export const INDIA_ROUTES = {
  privacy: "/privacy",
};
